import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthenticationRoutes} from './authentication.routing';
import {LoginComponent} from './login/login.component';
import {ForgotComponent} from './forgot/forgot.component';
import {LookScreen} from './lock-screen/lock-screen.component';
import {NgxLoadingModule} from 'ngx-loading';
import {SharedModule} from '../../shared/shared.module';
import {ToastyModule} from 'ng2-toasty';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AuthenticationRoutes),
    FormsModule,
    ReactiveFormsModule,
    NgxLoadingModule.forRoot({}),
    ToastyModule.forRoot()
  ],
  declarations: [LoginComponent, ForgotComponent, LookScreen]
})

export class AuthenticationModule {
}



// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/authentication/authentication.module.ts